import SignInForm from '../modules/forms/auth/sign-in';
import SignUpForm from '../modules/forms/auth/sign-up';
import VerificationForm from '../modules/forms/auth/verification';
import ResetPasswordForm from '../modules/forms/auth/reset-password';
import ChangePasswordForm from '../modules/forms/auth/change-password';

export default function setAuthScripts () {
    const path = window.location.pathname;

    const routes = {
        signIn: () => path === '/auth/sign-in/',
        signUp: () => path === '/auth/sign-up/',
        resetPassword: () => path === '/auth/reset-password/',
    };

    if (!Object.values(routes).some((route) => route())) return;

    // Locations

    if (routes.signIn() || routes.signUp) {
        const moBtn = document.querySelector('.mo_btn');
    
        if (moBtn) {
          moBtn.removeAttribute('style');
    
          const text = moBtn.textContent;
          const icon = moBtn.querySelector('i');
    
          const span = document.createElement('span');
          span.textContent = text;
    
          moBtn.innerHTML = '';
          moBtn.append(icon);
          moBtn.append(span);
        }
    }

    if (routes.signIn()) new SignInForm('#sign-in-form');

    if (routes.signUp()) {
        new SignUpForm('#sign-up-form');
        new VerificationForm('#email-verification-form');
    }

    if (routes.resetPassword()) {
        new ResetPasswordForm('#reset-password-form');
        new ChangePasswordForm('#change-password-form');
    }
}
